import { render, staticRenderFns } from "./VInfiniteScroll.vue?vue&type=template&id=525e96a0"
import script from "./VInfiniteScroll.vue?vue&type=script&lang=js"
export * from "./VInfiniteScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports